import { Injectable } from '@angular/core';
import {jwtDecode, JwtPayload} from 'jwt-decode';

@Injectable({
  providedIn: 'root'
})
export class TokenService {

  private readonly accessTokenKey = 'dymly-access';
  private readonly refreshTokenKey = 'dymly-refresh';

  private saveToken(tokenType: string, token: string) {
    localStorage.setItem(tokenType, token);
  }

  public saveAccessToken(token: string) {
    this.saveToken(this.accessTokenKey, token);
  }

  public saveRefreshToken(token: string) {
    this.saveToken(this.refreshTokenKey, token);
  }

  public getAccessToken(): string | null {
    return localStorage.getItem(this.accessTokenKey);
  }

  public getRefreshToken(): string | null {
    return localStorage.getItem(this.refreshTokenKey);
  }

  public clearTokens() {
    localStorage.removeItem(this.accessTokenKey);
    localStorage.removeItem(this.refreshTokenKey);
  }

  public saveTokens(accessToken: string, refreshToken: string) {
    this.saveAccessToken(accessToken);
    this.saveRefreshToken(refreshToken);
  }

  public isTokenValid(token: string): boolean {
    let decodedToken: JwtPayload;
    try {
      decodedToken = jwtDecode<JwtPayload>(token);
    } catch (_e) {
      console.error('Error decoding token:', _e);
      // If token cannot be decoded, treat as invalid
      return false;
    }
    const exp = decodedToken.exp;
    if (!exp) {
      return false;
    }
    // exp in JWT is in seconds since epoch; convert to ms for comparison with Date.now()
    return exp * 1000 > Date.now();
  }
}
